import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      gap: spacing(6),
    },
    field: {
      width: `calc(50% - ${spacing(3)}px)`,
    },
    fieldFulWidth: {
      width: '100%',
    },
    heading: {
      color: colors.black.darker,
      lineHeight: '24px',
      fontSize: 16,
      fontWeight: 600,
    },
    label: {
      color: '#1D2433', // TODO: Upldate this with new palette
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '16px',
      marginBottom: spacing(2),
    },
    row: {},
    selectRoot: {
      width: '100%',
    },
  });
